/* Native Shopify bundles: the parent variant owns the cart price and components. */
(() => {
  const flT = globalThis.FellinoI18n.text;
  if (window.FellinoBundles) { window.FellinoBundles.init(document); return; }
  let adding = false;
  const root = window.Shopify?.routes?.root || '/';
  function init(scope) {
    scope.querySelectorAll('[data-fellino-bundles]').forEach(section => {
      if (section.dataset.initialized) return;
      section.dataset.initialized = 'true';
      const format = new Intl.NumberFormat(document.documentElement.lang || (globalThis.FellinoI18n?.locale || 'de-DE'), {style:'currency', currency:section.dataset.currency || 'EUR'});
      const money = cents => format.format(cents / 100);
      const states = new Map();
      // Native net contents include the whole multipack, never shipping weight.
      function unitPriceText(option, cents) {
        const data = option.dataset;
        const quantity = Number(data.unitQuantity), reference = Number(data.unitReference);
        const quantityUnit = (data.unitQuantityUnit || '').toLowerCase();
        const referenceUnit = (data.unitReferenceUnit || '').toLowerCase();
        const scales = {
          mg:['mass', 0.001], g:['mass', 1], kg:['mass', 1000],
          ml:['volume', 1], cl:['volume', 10], l:['volume', 1000]
        };
        const from = scales[quantityUnit], to = scales[referenceUnit];
        const compatible = quantityUnit && referenceUnit &&
          (quantityUnit === referenceUnit || (from && to && from[0] === to[0]));
        if (!Number.isSafeInteger(cents) || cents < 0 ||
            !Number.isFinite(quantity) || quantity <= 0 ||
            !Number.isFinite(reference) || reference <= 0 || !compatible) {
          return Number(data.unitPriceBasePrice) === cents ? (data.unitPrice || '') : '';
        }
        const factor = quantityUnit === referenceUnit ? 1 : to[1] / from[1];
        const amount = Math.round(cents * reference * factor / quantity);
        if (!Number.isSafeInteger(amount)) return '';
        const label = data.unitPriceLabel ? ` (${data.unitPriceLabel})` : '';
        const referenceText = reference === 1 ? '' : reference.toLocaleString(
          document.documentElement.lang || (globalThis.FellinoI18n?.locale || 'de-DE')
        );
        return `${money(amount)} / ${referenceText}${data.unitReferenceUnit}${label}`;
      }
      function notice(card, message) {
        const node = card.querySelector('[data-bundle-notice]');
        node.textContent = message; node.hidden = !message;
      }
      function refreshVisibility() {
        const cards = Array.from(states.keys());
        if (cards.some(card => card.hasAttribute('data-maul-bundle'))) {
          section.hidden = cards.every(card => card.hidden);
          const visibleCount = cards.filter(card => !card.hidden).length;
          section.querySelector('.fl-bundles-grid')?.style.setProperty('--bundle-columns', String(Math.max(1, visibleCount)));
          const swipe = section.querySelector('.fl-bundles-swipe');
          if (swipe) swipe.hidden = visibleCount < 2;
        }
      }
      async function syncPrice(card, native, fresh = false) {
        const state = states.get(card), id = String(native.id);
        if (state.pending?.id === id) return state.pending.promise;
        state.syncingId = id; state.priceErrorId = null;
        state.button.disabled = true; state.button.textContent = flT("s2705ec8321ce");
        const promise = (async () => {
          try {
            const response = await fetch(root + 'apps/fellino-treue/proxy.php?bundle_variant=' + encodeURIComponent(id) + (fresh ? '&fresh=1' : ''), {
              credentials:'same-origin', headers:{'Accept':'application/json'}, cache:'no-store'
            });
            const data = await response.json();
            if (!response.ok) throw new Error(data.error || flT("s263e49d4ece2"));
            const expected = state.data.components[id].map(String).sort();
            if (String(data.id) !== id || data.currency !== (section.dataset.currency || 'EUR') ||
                !Number.isSafeInteger(data.price) || data.price <= 0 || !Number.isSafeInteger(data.total) ||
                data.price !== Math.round(data.total * 95 / 100) || !Array.isArray(data.components) ||
                data.components.length !== 2 || data.components.some(c => !Number.isSafeInteger(c.price) || c.price <= 0) ||
                data.components.reduce((sum,c) => sum + c.price, 0) !== data.total ||
                JSON.stringify(data.components.map(c => String(c.id)).sort()) !== JSON.stringify(expected)) {
              throw new Error(flT("sea169e1b1c5e"));
            }
            states.forEach(current => {
              const found = current.data.variants.find(v => String(v.id) === id);
              if (found) { found.price = data.price; found.available = data.available; }
            });
            section.querySelectorAll('[data-bundle-variant] option').forEach(option => {
              const component = data.components.find(c => String(c.id) === option.value);
              if (component) {
                option.dataset.price = String(component.price);
                option.dataset.available = String(component.available);
              }
            });
            return data;
          } catch (error) {
            error.bundlePriceCheck = true;
            state.priceErrorId = id; state.priceError = error.message;
            throw error;
          } finally {
            if (state.syncingId === id) state.syncingId = null;
            if (state.pending?.id === id) state.pending = null;
            states.forEach((_, current) => update(current));
          }
        })();
        state.pending = {id, promise};
        return promise;
      }
      function update(card) {
        const state = states.get(card);
        if (state.strict) {
          card.hidden = !Object.values(state.data.components).some(ids => ids.map(String).includes(state.mainId));
          if (card.hidden) { state.variant = null; state.button.disabled = true; refreshVisibility(); return; }
        }
        const ids = []; let total = 0, available = true;
        card.querySelectorAll('[data-bundle-item]').forEach(item => {
          const selected = item.querySelector('select')?.selectedOptions[0];
          const price = Number(selected?.dataset.price);
          if (!selected || !Number.isSafeInteger(price) || price < 0) { available = false; return; }
          ids.push(String(selected.value)); total += price;
          available = available && selected.dataset.available === 'true';
          item.querySelector('[data-bundle-item-price]').textContent = money(price);
          const unit = item.querySelector('[data-bundle-unit-price]');
          if (unit) unit.textContent = unitPriceText(selected, price);
          const img = item.querySelector('[data-bundle-image]');
          if (img && selected.dataset.image) img.src = selected.dataset.image;
          item.querySelectorAll('[data-bundle-product-link]').forEach(link => {
            const url = new URL(link.href, window.location.origin);
            url.searchParams.set('variant', selected.value); link.href = url.href;
          });
        });
        const native = state.data.variants.find(v => {
          const components = state.data.components[String(v.id)];
          return ids.length === 2 && Array.isArray(components) && components.length === 2 &&
            ((String(components[0]) === ids[0] && String(components[1]) === ids[1]) ||
             (String(components[1]) === ids[0] && String(components[0]) === ids[1]));
        });
        const price = Number(native?.price);
        // Sale prices are valid inputs. Reconcile the native cart price when it differs.
        const expectedPrice = Math.round(total * 95 / 100);
        const priced = Number.isSafeInteger(price) && Math.abs(price - expectedPrice) <= 1;
        state.candidate = available && native?.available ? native : null;
        state.variant = state.candidate && priced ? native : null;
        const syncing = state.syncingId === String(native?.id);
        const failed = state.priceErrorId === String(native?.id);
        state.displayPrice = priced ? price : expectedPrice;
        card.querySelector('[data-bundle-regular]').textContent = money(total);
        card.querySelector('[data-bundle-total]').textContent = state.candidate ? money(state.displayPrice) : '—';
        card.querySelector('[data-bundle-saving]').textContent = state.candidate ? money(total - state.displayPrice) : '—';
        state.button.disabled = !state.candidate || adding || syncing;
        if (!adding) state.button.textContent = syncing ? flT("s2705ec8321ce") : (failed ? flT("s948643cb59e8") : flT("se217f6424240"));
        refreshVisibility();
        notice(card, !state.candidate ? flT("s2a49fbf973b1") : failed ? state.priceError : '');
        if (state.candidate && !priced && !syncing && !failed) syncPrice(card, native).catch(() => {});
      }
      function matchPartner(card, changed) {
        const selects = Array.from(card.querySelectorAll('[data-bundle-variant]'));
        const other = selects.find(s => s !== changed);
        if (!other) return;
        const state = states.get(card);
        const compatible = state.data.variants.filter(v => v.available).map(v => state.data.components[String(v.id)])
          .filter(ids => Array.isArray(ids) && ids.map(String).includes(String(changed.value)))
          .map(ids => ids.map(String).find(id => id !== String(changed.value)));
        if (state.strict) {
          Array.from(other.options).forEach(option => {
            const matches = compatible.includes(String(option.value));
            option.hidden = !matches;
            option.disabled = !matches || option.dataset.available !== 'true';
          });
          const color = changed.selectedOptions[0]?.dataset.color;
          const choices = Array.from(other.options).filter(option => !option.disabled);
          const sameColor = choices.filter(option => color && option.dataset.color === color);
          const preferred = state.data.preferred?.[String(changed.value)];
          const current = choices.find(option => option.value === other.value);
          const best = sameColor.find(option => option.value === preferred) ||
            (current && sameColor.includes(current) ? current : sameColor[0]) ||
            choices.find(option => option.value === preferred) || current || choices[0];
          if (best) other.value = best.value;
          return;
        }
        if (compatible.includes(String(other.value))) return;
        const option = Array.from(other.options).find(o => !o.disabled && compatible.includes(String(o.value)));
        if (option) other.value = option.value;
      }
      section.querySelectorAll('[data-bundle-card]').forEach(card => {
        let data;
        try {
          data = JSON.parse(card.querySelector('[data-native-bundle]').textContent);
          if (!data.components || !Array.isArray(data.variants)) throw new Error('Incomplete bundle');
          const live = new Map((data.liveVariants || []).map(v => [String(v.id), v]));
          data.variants = data.variants.map(v => live.get(String(v.id)) || v);
        } catch (_) { notice(card, flT("s66893d212ff4")); return; }
        const button = card.querySelector('[data-bundle-buy]');
        states.set(card, {data, button, variant:null, strict:card.hasAttribute('data-maul-bundle'), mainId:String(section.dataset.mainVariant)});
        const allowed = new Set(Object.values(data.components).flat().map(String));
        card.querySelectorAll('[data-bundle-item]').forEach(item => {
          const select = item.querySelector('select');
          const initialCount = select.options.length;
          Array.from(select.options).forEach(option => { if (!allowed.has(String(option.value))) option.remove(); });
          if (!select.selectedOptions[0] || select.selectedOptions[0].disabled) {
            const first = Array.from(select.options).find(option => !option.disabled);
            if (first) select.value = first.value;
          }
          const fixed = select.options.length === 1;
          select.hidden = fixed;
          const label = item.querySelector('[data-bundle-variant-label]');
          if (label) label.hidden = fixed;
          const summary = item.querySelector('[data-bundle-fixed-variant]');
          if (summary) {
            summary.hidden = !(fixed && initialCount > 1);
            summary.textContent = fixed && initialCount > 1 ? select.options[0].textContent : '';
          }
        });
        const mainSelect = card.querySelector('[data-position="1"] select');
        const currentState = states.get(card);
        if (currentState.strict && Array.from(mainSelect.options).some(option => option.value === currentState.mainId)) {
          mainSelect.value = currentState.mainId;
        }
        matchPartner(card, card.querySelector('[data-position="1"] select')); update(card);
        card.addEventListener('change', event => {
          if (!event.target.matches('[data-bundle-variant]')) return;
          event.target.dataset.userSelected = 'true';
          const state = states.get(card);
          if (state.strict) {
            if (event.target.closest('[data-position="1"]')) {
              state.mainId = String(event.target.value); matchPartner(card, event.target);
            }
            update(card); return;
          }
          matchPartner(card, event.target); update(card);
        });
        button.addEventListener('click', async () => {
          update(card);
          const state = states.get(card), candidate = state.candidate;
          const displayedPrice = state.displayPrice;
          if (adding || !candidate || state.syncingId) return;
          adding = true; button.disabled = true; button.setAttribute('aria-busy', 'true');
          button.textContent = flT("s969d26ff2456"); notice(card, '');
          try {
            await syncPrice(card, candidate, true);
            const variant = states.get(card).variant;
            if (!variant || String(variant.id) !== String(candidate.id)) {
              const error = new Error(flT("s917000ac4f8b"));
              error.requestRejected = true; throw error;
            }
            if (variant.price > displayedPrice + 1) {
              adding = false; button.removeAttribute('aria-busy');
              states.forEach((_, current) => update(current));
              notice(card, flT("s693f6583131b"));
              return;
            }
            const response = await fetch(root + 'cart/add.js', {
              method:'POST', credentials:'same-origin', headers:{'Content-Type':'application/json', 'Accept':'application/json'},
              body:JSON.stringify({items:[{id:Number(variant.id), quantity:1}]})
            });
            const result = await response.json();
            if (!response.ok) {
              const error = new Error(result.description || flT("s4134e7716b01"));
              error.requestRejected = true; throw error;
            }
            window.location.assign(root + 'cart');
          } catch (error) {
            adding = false; button.removeAttribute('aria-busy'); button.textContent = flT("se217f6424240");
            states.forEach((_, current) => update(current));
            notice(card, (error.requestRejected || error.bundlePriceCheck) ? error.message : flT("s679a85084a87"));
          }
        });
      });
      const onVariant = event => {
        if (!section.isConnected) { document.removeEventListener('variant:change', onVariant); return; }
        if (String(event.detail?.productId) !== section.dataset.productId) return;
        states.forEach((state, card) => {
          const select = card.querySelector('[data-position="1"] select');
          const id = String(event.detail?.variant?.id);
          if (state.strict) {
            state.mainId = id;
            if (select && Array.from(select.options).some(option => option.value === id)) {
              select.value = id; matchPartner(card, select);
            }
            update(card); return;
          }
          if (!select || select.dataset.userSelected || !Array.from(select.options).some(option => option.value === id)) return;
          select.value = id; matchPartner(card, select); update(card);
        });
      };
      document.addEventListener('variant:change', onVariant);
    });
  }
  window.FellinoBundles = {init};
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
